<template>
  <div>
    <Breadcrumb msg1="配镜业务" msg2="配镜订单" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="5"><el-input v-model="query.order_no" placeholder="订单号" clearable></el-input></el-col>
        <el-col :span="5">
          <el-select v-model="query.customer_id" filterable remote placeholder="按客户搜索" :remote-method="searchCustomer" clearable style="width: 100%">
            <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="query.status" placeholder="状态" clearable>
            <el-option v-for="s in statusList" :key="s" :label="s" :value="s"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新建订单</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="订单号" prop="orderNo" width="140"></el-table-column>
        <el-table-column label="客户" width="100"><template slot-scope="scope">{{ customerName(scope.row.customerId) }}</template></el-table-column>
        <el-table-column label="镜架" prop="frameName" width="110"></el-table-column>
        <el-table-column label="镜片" prop="lensSpec" show-overflow-tooltip></el-table-column>
        <el-table-column label="金额" prop="totalAmount" width="90"></el-table-column>
        <el-table-column label="已付" prop="paidAmount" width="90"></el-table-column>
        <el-table-column label="渠道" prop="channel" width="80"></el-table-column>
        <el-table-column label="下单日期" prop="orderDate" width="110"></el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="statusTag(scope.row.status)">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="330">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="view(scope.row.id)">详情</el-button>
            <el-button size="mini" type="success" v-if="scope.row.status === '待审核'" @click="flow(scope.row, 'audit')">审核</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.status === '已审核'" @click="flow(scope.row, 'processing')">开始加工</el-button>
            <el-button size="mini" type="warning" v-if="scope.row.status === '加工中'" @click="flow(scope.row, 'ready')">完工</el-button>
            <el-button size="mini" type="success" v-if="scope.row.status === '待取件'" @click="flow(scope.row, 'pickup')">取件</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.status === '已取件'" @click="flow(scope.row, 'complete')">完成</el-button>
            <el-button size="mini" type="danger" v-if="['待审核', '已审核', '加工中'].indexOf(scope.row.status) >= 0" @click="cancel(scope.row)">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="760px" :close-on-click-modal="false">
      <el-form :model="form" label-width="110px" v-if="show">
        <el-form-item label="客户" required>
          <el-select v-model="form.customer_id" filterable remote placeholder="输入姓名/手机号搜索" :remote-method="searchCustomer" style="width: 60%" @change="onCustomerChange">
            <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
          </el-select>
          <el-button type="text" style="margin-left: 10px" :disabled="!form.customer_id" @click="openPresPicker">带入处方</el-button>
        </el-form-item>
        <el-form-item label="关联处方">
          <el-input v-model="prescriptionLabel" placeholder="点击「带入处方」选择该客户的有效处方" readonly></el-input>
        </el-form-item>
        <el-form-item label="镜架">
          <el-select v-model="form.frame_id" filterable placeholder="选择镜架商品" style="width: 100%" @change="onFrameChange">
            <el-option v-for="p in frameProducts" :key="p.id" :label="p.name + ' ' + (p.spec || '')" :value="p.id"></el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-col :span="12"><el-form-item label="OD度数"><el-input v-model="form.od_degree" placeholder="如 -3.00/-0.75x180"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="OS度数"><el-input v-model="form.os_degree" placeholder="如 -2.75/-0.50x180"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="镜片类型">
            <el-select v-model="form.lens_type" style="width: 100%">
              <el-option label="单光" value="单光"></el-option>
              <el-option label="渐进多焦" value="渐进多焦"></el-option>
              <el-option label="防蓝光" value="防蓝光"></el-option>
              <el-option label="变色" value="变色"></el-option>
            </el-select>
          </el-form-item></el-col>
          <el-col :span="12"><el-form-item label="瞳距PD"><el-input v-model="form.pd"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="镜片规格"><el-input v-model="form.lens_spec"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="取件日期"><el-date-picker v-model="form.take_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker></el-col>
          <el-col :span="8"><el-form-item label="应收金额"><el-input v-model.number="form.total_amount" type="number"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="优惠金额"><el-input v-model.number="form.discount_amount" type="number"></el-input></el-form-item></el-col>
          <el-col :span="8"><el-form-item label="已收金额"><el-input v-model.number="form.paid_amount" type="number"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="渠道">
            <el-select v-model="form.channel" style="width: 100%">
              <el-option label="线下" value="线下"></el-option>
              <el-option label="线上" value="线上"></el-option>
            </el-select>
          </el-form-item></el-col>
          <el-col :span="12"><el-form-item label="销售员">
            <el-select v-model="form.salesperson_id" style="width: 100%">
              <el-option v-for="doc in doctors" :key="doc.id" :label="doc.realname" :value="doc.id"></el-option>
            </el-select>
          </el-form-item></el-col>
          <el-col :span="24"><el-form-item label="备注"><el-input v-model="form.remark" type="textarea"></el-input></el-form-item></el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">提交订单</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择处方" :visible.sync="presShow" width="600px">
      <el-table :data="presList" border size="small" @row-click="pickPres" highlight-current-row>
        <el-table-column prop="prescriptionNo" label="处方号"></el-table-column>
        <el-table-column prop="issueDate" label="开具日期"></el-table-column>
        <el-table-column prop="diagnosis" label="诊断"></el-table-column>
        <el-table-column prop="status" label="状态" width="80"></el-table-column>
      </el-table>
      <span slot="footer"><el-button @click="presShow = false">关闭</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import { loadCustomerMap, customerName } from '@/utils/customerName'
export default {
  components: { Breadcrumb },
  data () {
    return {
      statusList: ['待审核', '已审核', '加工中', '待取件', '已取件', '已完成', '已取消'],
      query: { page: 1, limit: 10, order_no: '', customer_id: null, status: '' },
      list: [],
      total: 0,
      show: false,
      dialogTitle: '',
      form: {},
      presShow: false,
      presList: [],
      prescriptionLabel: '',
      customerOptions: [],
      frameProducts: [],
      doctors: []
    }
  },
  created () {
    this.getData()
    loadCustomerMap(this.$axios.http)
    this.$axios.http.get('/users/doctors').then(r => { if (r.data.status === 200) this.doctors = r.data.data || [] })
    this.$axios.http.get('/products', { params: { page: 1, limit: 200, is_frame: 1 } }).then(r => {
      if (r.data.status === 200) this.frameProducts = r.data.data.records || []
    })
  },
  methods: {
    customerName,
    getData () {
      this.$axios.get('/glassesOrders', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    statusTag (s) {
      return { 待审核: 'warning', 已审核: 'primary', 加工中: '', 待取件: 'info', 已取件: 'success', 已完成: 'success', 已取消: 'danger' }[s] || ''
    },
    searchCustomer (kw) {
      if (!kw) return
      this.$axios.http.get('/customers/select', { params: { keyword: kw } }).then(r => {
        if (r.data.status === 200) this.customerOptions = r.data.data || []
      })
    },
    onCustomerChange () {
      this.form.prescription_id = null
      this.prescriptionLabel = ''
    },
    openPresPicker () {
      this.$axios.http.get(`/prescriptions/customer/${this.form.customer_id}`).then(r => {
        if (r.data.status === 200) {
          this.presList = (r.data.data || []).filter(p => p.status !== '已作废')
          this.presShow = true
        }
      })
    },
    pickPres (row) {
      this.form.prescription_id = row.id
      this.prescriptionLabel = row.prescriptionNo + '（' + (row.issueDate || '') + '）'
      this.presShow = false
    },
    onFrameChange (id) {
      const p = this.frameProducts.find(x => x.id === id)
      if (p) this.form.frame_name = p.name
    },
    add () {
      this.dialogTitle = '新建配镜订单'
      this.form = { customer_id: null, prescription_id: null, frame_id: null, frame_name: '', lens_type: '单光', lens_spec: '', od_degree: '', os_degree: '', pd: '', total_amount: 0, discount_amount: 0, paid_amount: 0, channel: '线下', salesperson_id: null, take_date: '', remark: '' }
      this.prescriptionLabel = ''
      this.show = true
    },
    save () {
      if (!this.form.customer_id) { this.$message.warning('请选择客户'); return }
      this.$axios.post('/glassesOrders', () => { this.show = false; this.getData() }, this.form)
    },
    flow (row, action) {
      this.$axios.put(`/glassesOrders/${row.id}/${action}`, () => this.getData())
    },
    cancel (row) {
      this.$prompt('请输入取消原因', '取消订单', { inputPattern: /\S+/, inputErrorMessage: '原因不能为空' }).then(({ value }) => {
        this.$axios.put(`/glassesOrders/${row.id}/cancel`, () => this.getData(), { reason: value })
      }).catch(() => {})
    },
    view (id) {
      this.$router.push(`/glasses-order/detail/${id}`)
    }
  }
}
</script>
